module.exports = __webpack_public_path__ + "img/icon-commodities.03736cb7.svg";